export type InvoiceIntent = {
  offeringCode: string;
  flow: 'credits' | 'build';
  creditQuantity?: number;
  roleName?: string;
  notes?: string;
};

const trimToUndefined = (value?: string | null) => {
  const trimmed = typeof value === 'string' ? value.trim() : '';
  return trimmed ? trimmed : undefined;
};

export const buildInvoiceDetailsUrl = (intent: InvoiceIntent) => {
  const params = new URLSearchParams();
  params.set('offeringCode', intent.offeringCode);
  params.set('flow', intent.flow);

  if (typeof intent.creditQuantity === 'number' && Number.isInteger(intent.creditQuantity)) {
    params.set('creditQuantity', String(intent.creditQuantity));
  }

  const roleName = trimToUndefined(intent.roleName);
  if (roleName) {
    params.set('roleName', roleName);
  }

  const notes = trimToUndefined(intent.notes);
  if (notes) {
    params.set('notes', notes);
  }

  return `/employer/invoice-details?${params.toString()}`;
};

export const parseInvoiceIntent = (search: string): InvoiceIntent | null => {
  const params = new URLSearchParams(search);
  const offeringCode = trimToUndefined(params.get('offeringCode'));
  const flow = trimToUndefined(params.get('flow'));
  if (!offeringCode || (flow !== 'credits' && flow !== 'build')) {
    return null;
  }

  const creditQuantityRaw = params.get('creditQuantity');
  const creditQuantity =
    creditQuantityRaw && Number.isInteger(Number(creditQuantityRaw))
      ? Number(creditQuantityRaw)
      : undefined;

  return {
    offeringCode,
    flow,
    creditQuantity,
    roleName: trimToUndefined(params.get('roleName')),
    notes: trimToUndefined(params.get('notes')),
  };
};
